import { HttpClient } from 'aurelia-fetch-client';
import { autoinject } from 'aurelia-framework';
import 'whatwg-fetch';
import { ApiResponse } from '../models/api-response';
import { ServiceResponse } from '../models/service-response';
import { State } from './global-state';
import { HPFServiceClient } from './hpfApi';

@autoinject
export class HpfConsumerService extends HPFServiceClient {

	constructor(
		state: State,
		http: HttpClient,
	) {
		super(state, http);
	}

	addCustomersToConsumerUser(request: AddCustomersToConsumerUserRequest): Promise<ServiceResponse> {
		return this.post('/consumers/customers', request)
			.then((apiResponse: ApiResponse) => {
				if (!apiResponse.isSuccessful) {
					// Removing apiResponse.getErrorMessage() call.
					// Chrome throws an error: apiResponse.getErrorMessage is not a function.
					return this.error('Unable to add customer(s)');
				}
				return this.success('', apiResponse.value);
			});
	}

	removeCustomersFromConsumerUser(request: RemoveCustomersFromConsumerUserRequest): Promise<ServiceResponse> {
		return this.delete('/consumers/customers', request)
			.then((apiResponse: ApiResponse) => {
				if (!apiResponse.isSuccessful) {
					// Removing apiResponse.getErrorMessage() call.
					// Chrome throws an error: apiResponse.getErrorMessage is not a function.

					if (apiResponse.errors && apiResponse.errors.length > 0) {
						return this.error(apiResponse.errors[0]);
					}

					return this.error('Unable to remove customer(s)');
				}
				return this.success('', apiResponse.value);
			});
	}

	setAssociatedCustomerNotificationPreferences(request: SetCustomerNotificationSettingsRequest): Promise<ServiceResponse> {
		return this.put(`/customers/${request.customerKey}/notificationSettings`, request)
			.then((apiResponse: ApiResponse) => {
				if (!apiResponse.isSuccessful) {
					return this.error('Unable to set notification preferences.');
				}
				return this.success('', apiResponse.value);
			});
	}

	setConsumerUserPreferredLanguage(request: SetConsumerUserPreferredLanguageRequest): Promise<ServiceResponse> {
		return this.post('/consumers/preferredLanguage', request)
			.then((apiResponse: ApiResponse) => {
				if (!apiResponse.isSuccessful) {
					return this.error('Unable to save preferred language.');
				}
				return this.success('');
			});
	}
}

export class AddCustomersToConsumerUserRequest {
	customerKeys: Array<number>;
}

export class RemoveCustomersFromConsumerUserRequest {
	customerKeys: Array<number>;
}

export class SetCustomerNotificationSettingsRequest {
	customerKey: number;

	isSmsOptedIn: boolean;

	isSmsValidated: boolean;

	isEmailOptedIn: boolean;

	emailAddress: string;

	mobilePhoneNumber: string;
}

export class SetConsumerUserPreferredLanguageRequest {
	languageCode: string;
	declinedToState: boolean;
	otherLanguage: string;
}
